/*
 * @Author: zhushitao
 * @Date: 2021-05-28 17:42:17
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-07-23 18:23:21
 * @Description:
 */
import { CMD_CODE } from '../constants/message';
import { IAppContext } from './type';

export type ICmd = { code?: string; data?: any; timeStmp: number };

// 命令消息不渲染 直接内部处理掉
class Cmd {
  private appContext;
  public cache: ICmd[] = [];
  constructor(appContext: IAppContext) {
    appContext.cmd = this;
    this.appContext = appContext;
  }

  public async send(content: { code?: string; data?: any } = {}) {
    this.cache.push({ timeStmp: Date.now(), ...content });

    try {
      switch (content.code) {
        case CMD_CODE.EXEC:
          if (content?.data && typeof content.data === 'function') {
            await content.data(this.appContext, content);
          }
          break;
        case CMD_CODE.RENDER:
          if (content.data) {
            this.appContext?.$refs?.$ghost &&
              this.appContext?.$refs?.$ghost?.current.render(content.data);
          }
          break;
        default:
          break;
      }
    } catch (error) {
      throw error;
    }
  }
}

export default Cmd;
